import Fraction from './fraction.js'

export const zero = new Fraction(0);
export const one = new Fraction(1);
export const minus = new Fraction(-1);

export class InputField{
  constructor(val = '0'){
    this.txt = val;
    this.error = false;
    try{
      this.frac = Fraction(this.txt);
    }catch(e){
      this.error = true;
    }
  }
  get input(){
    return this.txt;
  }
  set input(val){
    this.txt = val;
    this.error = false;
    try{
      this.frac = Fraction(this.txt);
    }catch(e){
      this.error = true;
    }
  }
}

export class Polynominal{
  constructor(f = zero){
    this.coeff = f.equals(zero) ? [] : [ f.clone() ];
  }
  get deg(){
    return this.coeff.length -1;
  }
  get print(){
    const result = []
    if(this.deg < 0){
      result.push( {deg:0, sign: '', coeff: '0'} );
    }else{
      for(let i=0; i<=this.deg; i++){
	if(! this.coeff[i].equals(zero)){
	  const sign = this.coeff[i].s < 0 ? '-' : i<this.deg ? '+' : '';
	  const t = this.coeff[i].s < 0 ? this.coeff[i].neg() : this.coeff[i];
	  let txt = ''
	  if(t.d > 1){
	    txt += '(' + t.toFraction() + ')';
	  }else if(! t.equals(one) || i == 0){
	    txt += t.toFraction();
	  }
	  result.unshift( {deg:i, sign: sign, coeff: txt} );
	}
      }
    }
    return result;
  }
  shrink(){
    while(this.coeff.length > 0 && this.coeff[this.coeff.length -1].equals(zero)){
      this.coeff.pop();
    }
  }
  input(ar){
    this.coeff = ar.map( input => input.frac ).reverse();
    this.shrink();
  }
  copy(){
    const q = new Polynominal();
    for(const t of this.coeff){
      q.coeff.push(t);
    }
    return q;
  }
  add(p){
    const q = new Polynominal();
    for(let i=0; i<= this.deg || i <= p.deg; i++){
      const result = i<= this.deg ? ( i <= p.deg ? this.coeff[i].add(p.coeff[i]) : this.coeff[i] ) : p.coeff[i];
      q.coeff.push(result);
    }
    q.shrink();
    return q;
  }
  sub(p){
    const q = new Polynominal();
    for(let i=0; i<= this.deg || i <= p.deg; i++){
      const result = i<= this.deg ? ( i <= p.deg ? this.coeff[i].sub(p.coeff[i]) : this.coeff[i] ) : p.coeff[i].neg();
      q.coeff.push(result);
    }
    q.shrink();
    return q;
  }
  mul(p){
    if(this.deg < 0 || p.deg < 0){
      return new Polynominal();
    }else{
      const q = new Polynominal();
      for(let i=0; i<= this.deg + p.deg; i++){
	q.coeff.push(zero);
      }
      for(let i=0; i<= this.deg; i++){
	for(let j=0; j<=p.deg; j++){
	  q.coeff[i+j] = q.coeff[i+j].add(this.coeff[i].mul(p.coeff[j]));
	}	
      }
      return q;
    }
  }
  mulc(f){
    const q = new Polynominal();
    for(const t of this.coeff){
      q.coeff.push(t.mul(f));
    }
    return q;
  }
  shift(n){
    const q = this.copy();
    for(let i=0;i<n;i++){
      q.coeff.unshift(zero);
    }
    return q;
  }
  div(p){
    let q = new Polynominal();
    let r = this.copy();
    if(p.deg >= 0){
      const l = p.leading().inverse();
      while(r.deg >= p.deg){
	const t = r.leading().mul(l);
	q = q.add( new Polynominal(t).shift(r.deg - p.deg) );
	r = r.sub( p.mulc(t).shift(r.deg - p.deg) );
      }
    }
    return {q:q, r:r};
  }
  leading(){
    return this.deg < 0 ? zero : this.coeff[this.deg];
  }
  monic(){
    if(this.deg < 0){
      return new Polynominal([]);
    }else{
      return this.mulc(this.leading().inverse());
    }
  }  
}
